"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const Vector_1 = __importDefault(require("ol/source/Vector"));
const Vector_2 = __importDefault(require("ol/layer/Vector"));
const Point_1 = __importDefault(require("ol/geom/Point"));
const Utils_1 = require("../Utils");
const style_1 = require("ol/style");
const ol_1 = require("ol");
const proj_1 = require("ol/proj");
class PointBuilder {
    constructor(map = new ol_1.Map()) {
        this.map = map;
    }
    get projections() {
        return { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
    }
    createNewLayer() {
        const source = new Vector_1.default();
        const pointLayer = new Vector_2.default({ source: source });
        (0, Utils_1.addLayerToMap)(pointLayer, 'point-layer', 100, this.map);
    }
    addPointIndicator(lon, lat, source) {
        const pointFeature = new ol_1.Feature({ geometry: new Point_1.default((0, proj_1.fromLonLat)([lon, lat])) });
        const fill = new style_1.Fill({ color: 'red' });
        const stroke = new style_1.Stroke({ color: 'red', width: 2 });
        const pointStyle = new style_1.Style({ image: new style_1.Circle({ radius: 5, fill: fill, stroke: stroke }) });
        pointFeature.setStyle(pointStyle);
        source.addFeature(pointFeature);
    }
    changeIndividualMarkerStyle(featureCode, newStyleOptions) {
        const layer = (0, Utils_1.findLayerById)('point-layer', this.map);
        if (layer) {
            const source = layer.getSource();
            const features = source.getFeatures();
            const feature = features.find((f) => f.get('code') === featureCode);
            if (!feature) {
                return;
            }
            const icon = new style_1.Icon({
                anchor: [10, 50],
                anchorXUnits: 'pixels',
                anchorYUnits: 'pixels',
                src: newStyleOptions.iconImg || feature.get('icon').getSrc(),
                scale: 1,
                color: newStyleOptions.color || feature.get('icon').getColor(),
            });
            const style = new style_1.Style({ image: icon });
            feature.set('style', style);
            feature.set('icon', icon);
            feature.setStyle(style);
        }
    }
    drawPoint(mapMarkerOptions, hasIndicator = false) {
        const hasPointLayer = (0, Utils_1.checkExistLayerById)('point-layer', this.map);
        if (!hasPointLayer) {
            this.createNewLayer();
        }
        const source = (0, Utils_1.findLayerById)('point-layer', this.map).getSource();
        const coordinates = mapMarkerOptions.geoData.split(' ');
        const lon = parseFloat(coordinates[0].substring(6));
        const lat = parseFloat(coordinates[1].slice(0, -1));
        const feature = new ol_1.Feature({ geometry: new Point_1.default((0, proj_1.fromLonLat)([lon, lat])) });
        const icon = new style_1.Icon({ anchor: [10, 50], anchorXUnits: 'pixels', anchorYUnits: 'pixels', src: mapMarkerOptions.iconImg, scale: 1, color: mapMarkerOptions.color });
        const style = new style_1.Style({ image: icon });
        feature.setStyle(style);
        source.addFeature(feature);
        feature.setProperties({
            layerId: 'point-layer',
            icon: icon,
            coordinates: coordinates,
            geodata: mapMarkerOptions.geoData,
            code: mapMarkerOptions.code,
            hover: mapMarkerOptions.enableHoverInteraction,
            selectInteraction: mapMarkerOptions.enableSelectInteraction,
            style: style,
        });
        if (hasIndicator)
            this.addPointIndicator(lon, lat, source);
    }
}
exports.default = PointBuilder;
